module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/id/3/1-5c948a9d694a0a7d36d71ac2e0570ffb.jpg";